'use client';

import {useState} from 'react';
import Image from 'next/image';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation} from 'swiper/modules';
import 'swiper/css';
import customer from '../../data/customer';
import './Customer.scss';

const getInitials = (name, company) => {
  if (name) return name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase();
  return company ? company.slice(0, 2).toUpperCase() : '??';
};

const Customer = () => {
  const [swiper, setSwiper] = useState(null);

  const slides = [...customer, ...customer].map((c, i) => (
    <SwiperSlide key={i}>
      <figure className='why-testimonial'>
        <blockquote className='why-quote'>{c.text}</blockquote>
        <figcaption className='why-figcaption'>
          <div className='why-avatar'>
            {c.avatar
              ? <Image src={c.avatar} alt={c.name || c.company} width={38} height={38} unoptimized style={{width:'100%',height:'100%',objectFit:'cover',borderRadius:'50%'}} />
              : getInitials(c.name, c.company)
            }
          </div>
          <div>
            {c.name && <div className='why-name'>{c.name}</div>}
            <div className='why-company'>{c.job} · {c.company}</div>
          </div>
        </figcaption>
      </figure>
    </SwiperSlide>
  ));

  return (
    <section className='customer-why'>
      <div className='why-inner'>
        <div className='why-top'>
          <div>
            <p className='why-label'>WHY TEAMS CHOOSE CYLERIAN</p>
            <h2 className='why-heading'>
              What{' '}
              <span className='why-accent'>security teams</span>{' '}
              say about Cylerian.
            </h2>
          </div>
          <div className='why-nav'>
            <button type='button' className='why-nav-btn' onClick={() => swiper?.slidePrev(300)} aria-label='Previous'>←</button>
            <button type='button' className='why-nav-btn' onClick={() => swiper?.slideNext(300)} aria-label='Next'>→</button>
          </div>
        </div>

        <Swiper
          modules={[Navigation]}
          spaceBetween={16}
          slidesPerView={3}
          loop={true}
          onSwiper={setSwiper}
          breakpoints={{
            0:    { slidesPerView: 1 },
            768:  { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
        >
          {slides}
        </Swiper>
      </div>
    </section>
  );
};

export default Customer;
